export const modifyCampaigns = (orderId, campaigns, autoRepeatActive) => {
  const modifiedCampaigns = [...campaigns];
  for (let i = 0; i < modifiedCampaigns.length; i++) {
    if (modifiedCampaigns[i].Order.Id === orderId) {
      modifiedCampaigns[i].Order.AutoRepeatActive = autoRepeatActive;
    }
  }
  return modifiedCampaigns;
};
